import { useCallback } from "react";

import type { AddonTypeName } from "app/contexts/AddonStateContext/const";
import { ADDON_HUB_PRESELECT_DEFAULTS } from "app/contexts/NoTouchPurchaseContext/useNoTouchPurchaseProvider";
import { allTrackers } from "app/services/track/track";
import { goToAddonsPage } from "app/UtilitiesAndConstants/UtilityFunctions/goToAddonsPage";

interface IUseNoTouchPurchaseSummaryModalSuggestionsProps {
    addonType: AddonTypeName;
}

interface IUseNoTouchPurchaseSummaryModalSuggestionsApi {
    handleLinkClick: () => void;
    handleSuggestionClick: (suggestionAddonType: string) => void;
}

export const useNoTouchPurchaseSummaryModalSuggestions = ({
    addonType,
}: IUseNoTouchPurchaseSummaryModalSuggestionsProps): IUseNoTouchPurchaseSummaryModalSuggestionsApi => {
    const handleLinkClick = useCallback(() => {
        allTrackers.dispatchTrackEvent("popup", "click", `one click purchase/click other add on hub/${addonType}`);
        goToAddonsPage({});
    }, [addonType]);

    const handleSuggestionClick = useCallback(
        (suggestionAddonType: AddonTypeName) => {
            const packageId = ADDON_HUB_PRESELECT_DEFAULTS[suggestionAddonType];
            allTrackers.dispatchTrackEvent(
                "popup",
                "click",
                `one click purchase/click secondary add on ${packageId}/${addonType}`,
            );
            goToAddonsPage({
                packageIds: [packageId],
            });
        },
        [addonType],
    );

    return {
        handleLinkClick,
        handleSuggestionClick,
    };
};
